import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import Modal from '@deprecated-ui/common/Modal';
import color from '@deprecated-ui/_style/color';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useEffect, useState } from 'react';
import Image from 'global/Image';
import { proExpirySelector } from 'lib/entities/profile';
import PaywallAnalytics from 'features/paywall/analytics';
import { Container } from './styled';

interface Props {
  visible?: boolean;
  onOk?: () => void;
}

function SuccessSubscribeModal({ visible, onOk }: Props) {
  const [duration, setDuration] = useState<string | null>(null);
  const proExpiry = useSelector(proExpirySelector);
  const expiredAt = moment(proExpiry).format('D MMMM YYYY');

  useEffect(() => {
    if (!window || !window.localStorage) {
      return () => {};
    }

    setDuration(localStorage.getItem('plan-duration') || '');

    return () => {
      localStorage.removeItem('plan-duration');
    };
  }, []);

  const handleConfirmSuccess = () => {
    if (onOk) onOk();

    PaywallAnalytics.onClickSuccessSubscribe();
  };

  return (
    <Modal width="375px" centered visible={visible} onCancel={onOk}>
      <Container>
        <Image
          src="/icon/success-subscribe.svg"
          width="160px"
          height="120px"
          alt="Success Subscribe"
        />
        {/* @ts-expect-error */}
        <Text size="18px" family="bold" mb="12px" mt="24px">
          Berhasil Berlangganan
        </Text>
        {/* Temporary Hide */}
        <Text size="14px" height="21px">
          Masa aktif Stockbit PRO akan berlangsung selama
        </Text>
        <Text size="14px">
          <strong>{duration}</strong> dan akan berakhir pada{' '}
          <strong>{expiredAt}</strong>
        </Text>

        <Button
          type="primary"
          width="100%"
          height="44px"
          // @ts-expect-error
          mt="32px"
          onClick={handleConfirmSuccess}
        >
          <Text family="bold" color={color.light}>
            Oke
          </Text>
        </Button>
      </Container>
    </Modal>
  );
}
export default SuccessSubscribeModal;
